/* tslint:disable */

declare var Object: any;
export interface TeodsurveyquestoptInterface {
  "surveyCode": string;
  "libCode": string;
  "companyCode": string;
  "optCode": string;
  "optName"?: string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
}

export class Teodsurveyquestopt implements TeodsurveyquestoptInterface {
  "surveyCode": string;
  "libCode": string;
  "companyCode": string;
  "optCode": string;
  "optName": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  constructor(data?: TeodsurveyquestoptInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodsurveyquestopt`.
   */
  public static getModelName() {
    return "Teodsurveyquestopt";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodsurveyquestopt for dynamic purposes.
  **/
  public static factory(data: TeodsurveyquestoptInterface): Teodsurveyquestopt{
    return new Teodsurveyquestopt(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodsurveyquestopt',
      plural: 'Teodsurveyquestopts',
      path: 'Teodsurveyquestopts',
      properties: {
        "surveyCode": {
          name: 'surveyCode',
          type: 'string'
        },
        "libCode": {
          name: 'libCode',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "optCode": {
          name: 'optCode',
          type: 'string'
        },
        "optName": {
          name: 'optName',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodsurveyquestopt.ts